<template>
  <div>
    <p>{{ adSet.name }}</p>

    <mortgage-campaign-adset-preview-summary-row
      name="Product Type"
      :items="adSet.loan_purposes"
    ></mortgage-campaign-adset-preview-summary-row>

    <mortgage-campaign-adset-preview-summary-row
      name="Loan Size"
      :items="loanSizes"
    ></mortgage-campaign-adset-preview-summary-row>

    <mortgage-campaign-adset-preview-summary-row
      name="States Included"
      :items="states"
      label="id"
    ></mortgage-campaign-adset-preview-summary-row>
  </div>
</template>

<script type="text/babel">
  export default {
    props: {
      adSet: {
        type: Object
      },
      dimensions: {
        type: Object
      }
    },
    computed: {
      allStatesSelected () {
        return this.adSet.locations.length >= 50;
      },
      loanSizes () {
        return _.sortBy(this.adSet.loan_sizes, ['label']);
      },
      states () {
        if (this.allStatesSelected) {
          return [{ id: 'All States ' }];
        }

        return _.orderBy(this.adSet.locations, [location => location.id.toLowerCase()], ['asc']);
      }
    }
  };
</script>
